// migrationHistorySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { commonService } from "../../services/common.services";
import { apiConstants } from "../../constant/api.constant";

const initialState = {
  history: [],
  loading: false,
  error: null,
};

// Async Thunk to fetch migration history
export const getMigrationHistory = createAsyncThunk(
  "migrationHistory/getMigrationHistory",
  async (data, { rejectWithValue }) => {
    try {
      const response = await commonService.getWithToken(apiConstants.GET_MIGRATION_HISTORY, data);
      if (response && response.success && response.data) {
        return response.data; // return whole array, not [0]
      } else {
        return rejectWithValue("Failed to fetch migration history.");
      }
    } catch (error) {
      return rejectWithValue(error.message || "An error occurred.");
    }
  }
);

const migrationHistorySlice = createSlice({
  name: "migrationHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMigrationHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMigrationHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.history = action.payload || [];
      })
      .addCase(getMigrationHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch data.";
      });
  },
});

export default migrationHistorySlice.reducer;
